export const downloadStringAsFile = (data: string, filename: string) => {
  const anchor = document.createElement('a')

  anchor.download = filename
  anchor.href = data
  anchor.click()
}
